export default "__VITE_ASSET__Cvs0mBOn__"